import React from "react";



function About4() {
    return (
        <div>

            <section className="cta-section padding-bottom">
                <div className="container">
                    <div className="row cta-wrapper gx-0">
                        <div className="col-lg-6">
                            <div className="section-heading white">
                                <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}>Innovative IT Solutions for a Digital Future</h2>
                            </div>
                        </div>
                       <div className="cta-men wow fade-in-bottom" data-wow-delay="200ms" />
                    </div>
                    <div className="row promo-item-wrapper gx-0">
                        <div className="col-lg-4">
                            <div className="promo-item">
                                <i className="fas fa-laptop-code" />
                                <div className="promo-content">
                                    <h3>IT Solutions</h3>
                                    <p>Providing innovative software and technology solutions.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="promo-item">
                                <i className="fas fa-cloud" />
                                <div className="promo-content">
                                    <h3>Cloud Services</h3>
                                    <p>Secure and scalable cloud computing solutions.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="promo-item">
                                <i className="fas fa-shield-alt" />
                                <div className="promo-content">
                                    <h3>Cybersecurity</h3>
                                    <p>Protecting your business from digital threats.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default About4;
